import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import extraContent0 from "./components/extra-content-0";
import extraContent100 from "./components/extra-content-100";
import sti_0 from "./components/sti-0";
import sti_100 from "./components/sti-100";
import d50_0 from "./components/d50-0";
import d50_100 from "./components/d50-100";
import t30_0 from "./components/t30-0";
import t30_100 from "./components/t30-100";

const principle: Slide = {
  description:
    "In many classrooms, the existing sound absorption is insufficient to yield optimal acoustic conditions. To reach them, additional sound absorption is needed. Choose between different amounts of additional absorption (0% leaves the room as is, 100% yields optimal conditions according to DIN 18041) . See how it affects the values of objective parameters. Listen to the sound of a female speaker at two different positions.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {
            label: "Extra absorption",
          },
          items: [{ name: "0%" }, { name: "100%" }],
        },
        {
          type: "button",
          options: {
            label: "Parameter",
          },
          items: [{ name: "STI" }, { name: "D<sub>50</sub>" }, { name: "T<sub>30</sub>" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [
        [extraContent0, extraContent0, extraContent0],
        [extraContent100, extraContent100, extraContent100],
      ],
      components: [
        [sti_0, d50_0, t30_0],
        [sti_100, d50_100, t30_100],
      ],
    },
  },
};

export default principle;
